module.exports = __webpack_public_path__ + "46220ea3caadb7ce87dd6e415b0e30db.svg";